<div class="flex flex-row items-center gap-3 px-2">
  <div class="h-8 w-8 rounded-full bg-background-extra-light"></div>
  <div class="flex flex-1 flex-col gap-1">
    <div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>
    <div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>
  </div>
</div>
<div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>
<div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>
<div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>
<div class="h-[18px] w-full rounded-lg bg-background-extra-light"></div>

<div class="flex justify-end gap-4">
  <div class="flex h-10 w-10 rounded-xl bg-background-extra-light"></div>
  <div class="flex h-10 w-10 rounded-xl bg-background-extra-light"></div>
</div>
